import { render, staticRenderFns } from "./College.vue?vue&type=template&id=413dca0d&scoped=true"
import script from "./College.vue?vue&type=script&lang=js"
export * from "./College.vue?vue&type=script&lang=js"
import style0 from "./College.vue?vue&type=style&index=0&id=413dca0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413dca0d",
  null
  
)

export default component.exports